<template>
    <div class="con" :class="{'dark':active2,'animated fadeInDown':showa}">
        <div class="main">
            <img class="a" src="../assets/home/w1.png" alt="" @click="goto(0)">
            <img class="b" src="../assets/home/b.png" alt="" @click="goto(0)">
            <ul>
                <li v-for="(item,index) in $t('list')" :key="index" @click="goto(index)" :class="{'showLine':select===index}">{{item}}</li>
                <li>
                    <i class="iconfont icon-diqiu"></i>
                </li>
            </ul>
            <div class="right">
                <a href="http://mail.junanres.com" target="_blank">
                    <i class="iconfont icon-youxiang"></i>
                   <span> {{$t('etext')}}</span>
                </a>
                <el-select v-model="value" placeholder="请选择" @change="getLan">
                    <el-option
                            v-for="item in options"
                            :label="item.label"
                            :value="item.value"
                            :key="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>

        <div class="top animated fadeInUp">
            <img class="mImg" src="../assets/home/w1.png" alt="" @click="goto(0)">
            <img class="mImg2" src="../assets/home/b.png" alt="" @click="goto(0)">
            <div class="mNav" :class="{active: menuOpen}" @click="menuOpen=!menuOpen">
                <span class="burger"></span>
                <span class="burger"></span>
                <span class="burger"></span>
            </div>
        </div>
        <div class="menuBox" :class="{open: menuOpen}">
            <div class="item">
                <span v-for="(item,index) in $t('list')" :key="index" @click="goto(index)">{{item}}</span>
                <a href="http://mail.junanres.com" target="_blank">
                    <span>  {{$t('etext')}}</span>
                </a>
                <div>
                    <p @click="change('zh-CN')">CN</p>
                    <p @click="change('en')">EN</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    import { setup } from "../local/index"
    export default {
        name: "first",
        data(){
            return{
                showa:true,
                options: [{
                    value: 'a',
                    label: 'LANGUAGE（ENG）'
                }, {
                    value: 'b',
                    label: 'LANGUAGE（CHN）'
                }],
                value: 'a',
                select:0,
                menuOpen:false,
                active2:false,
                scrollbar:'',
                top:'',
                list:[
                    "首页",
                    "走进君安",
                    "君安文化",
                    "产业布局",
                    "君安资讯",
                    "人力资源",
                    "联系我们"
                ]
            }
        },
        watch: {
            $route: 'getScrollbar'
        },
        mounted(){
            if( this.$i18n.locale === 'en'){
                this.value='a'
            }else{
                this.value='b'
            }
            this.$nextTick(()=>{
                this.getScrollbar()
            })
        },
        methods:{
            getLan(n){
                if(n==='a'){
                    this.$i18n.locale = 'en'
                    window.localStorage.setItem('language', 'en')
                    setup( 'en');
                    this.$router.go(0)
                }else{
                    this.$i18n.locale = 'zh-CN'
                    window.localStorage.setItem('language', 'zh-CN')
                    setup( 'zh-CN');
                    this.$router.go(0)
                }
            },
            change(n){
                this.$i18n.locale = n
                console.log(n)
                window.localStorage.setItem('language', n)
                setup(n);
                this.$router.go(0)
            },
            goto(n){
                this.select=n
                this.menuOpen=false
                this.showa=false
                localStorage.setItem('index',n)
                if(n===0){
                    this.$router.push({path:'/home'})
                }else if(n===2){
                    this.$router.push({path:'/culture'})
                }else if(n===3){
                    this.$router.push({path:'/cy'})
                }else if(n===4){
                    this.$router.push({path:'/news'})
                }else if(n===6){
                    this.$router.push({path:'/contact'})
                }else if(n===5){
                    this.$router.push({path:'/human'})
                }else {
                    this.$router.push({path:'/about'})
                }
            },
            scrollHeader(scrollTop){
                this.active2=scrollTop>200 ? true : false
            },
            getScrollbar(){
                this.$nextTick(()=>{
                    this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                    this.active2=false
                    this.showa=true
                    this.select=parseInt(localStorage.getItem('index'))
                    let scrollHeader=this.scrollHeader
                    if(this.scrollbar){
                        this.scrollbar.addListener((status) => {
                            scrollHeader(status.offset.y)
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        position: fixed;
        top:0;
        left:0;
        z-index: 1000;
        transition: all 600ms;
        .animated{
            animation-delay: 600ms;
        }
        .main{
            width:80%;
            margin-left: 10%;
            display: flex;
            flex-direction: row;
            transition: all 2s ;
            img{
                height:53px;
                width:187px;
                margin-top:25px;
                cursor: pointer;
                padding-bottom: 10px;
            }
            .a{
                display: block;
                transition: all 600ms;
            }
            .b{
                display: none;
                transition: all 600ms;
            }
            ul{
                list-style: none;
                display: flex;
                flex-direction: row;
                color:white;
                justify-content: space-between;
                width:55%;
                margin-left: 5%;
                margin-top: 10px;
                li{
                    font-size: 14px;
                    cursor: pointer;
                    transition: all 2s;
                    padding-top: 30px;
                    position: relative;
                    font-family: 'sn';
                }
                li::before{
                    content:'';
                    position: absolute;
                    left:0;
                    bottom:0;
                    width:0;
                    height:2px;
                    background-color: white;
                    display: inline-block;
                    border-radius: 10px;
                    transition: all 600ms;
                }
                .showLine::before{
                    width:100%;
                }
            }
            .right{
                padding-top: 35px;
                display: flex;
                flex-direction: row;
               a{
                   color:white;
                   font-size: 14px;
                   padding-right: 20px;
                   padding-left: 10px;
                   display: flex;
                   flex-direction: row;
                   i{
                       vertical-align: center;
                   }
                   span{
                      display: inline-block;
                       line-height: 30px;
                       padding-left: 10px;
                   }
               }
            }
        }
        .top{
            display: none;
        }
        .menuBox{
            position: fixed;
            top: 89px;
            left:-100%;
            height:100vh;
            width: 100%;
            background-color: rgba(12,54,101,.9);
            z-index: 1010;
            transition: .8s;
            display: block;
        }
        .menuBox.open{
            left:0;
        }
        .menuBox .item{
            margin-top: 50px;
        }
        .menuBox .item span{
            display: block;
            font-size: 18px;
            color:white;
            width:100%;
            padding: 15px 0px;
            text-align: center;
        }
        .menuBox .item div{
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding: 15px 0;
            p{
                color:white;
                padding-left: 10px;
                cursor: pointer;
            }
        }
        @media screen and (min-width: 2200px){
            .main{
                ul{
                    width:60%;
                }
            }
        }
        @media screen and (max-width: 1440px){
            .main{
                width:90%;
                margin-left: 5%;
                ul{
                    width:50%;
                }
            }
        }
        @media screen and (max-width: 1280px){
            .main{
                ul{
                    width:49%;
                }
            }
        }
        @media screen and (max-width:1279px){
            .main{
                display: none;
            }
            .top{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width:100%;
                padding: 20px 0px;
                transition: all 2s;
                background-color: rgba(12,54,101,.5);
            }
            .mImg{
                height:50px;
                object-fit: cover;
                margin-left: 20px;
                display: block;
                transition: all 600ms;
            }
            .mImg2{
                height:50px;
                object-fit: cover;
                margin-left: 20px;
                display: none;
                transition: all 600ms;
            }
            .mNav{
                display: block;
                transition: .8s;
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 60px;
            }
            .mNav .burger{
                width: 32px;
                height: 4px;
                background-color: white;
                position: absolute;
                top: 28px;
                left: 50%;
                margin: 0px 0px 0px -16px;
                transform-origin: center;
                transition: .8s;
            }
            .mNav .burger:nth-of-type(2){
                top: 38px;
            }
            .mNav .burger:nth-of-type(3){
                top: 48px;
            }
            .mNav.active{
                background-color:#0C3665;
            }
            .mNav.active .burger{
                background-color: #fff;
            }
            .mNav.active .burger:nth-of-type(1){
                top: 40px;
                transform: rotate(225deg);
            }
            .mNav.active .burger:nth-of-type(2){
                left: -100%;
                opacity: 0;
            }
            .mNav.active .burger:nth-of-type(3){
                top: 40px;
                transform: rotate(-225deg);
            }
        }
    }
    .dark{
        background-color: white;
        top:-20px;
        .main{
            .a{
                display: none;
            }
            .b{
                display: block;
            }
            ul{
                color:black;
                li:hover::before{
                    width:100%;
                    background-color: #0C3665;
                }
                .showLine::before{
                    background-color: #0C3665;
                }
            }
            .right{
                a{
                    color:black;
                }
                .icon-youxiang:before {
                    color:black;
                }
            }
        }
        @media screen and (max-width:1279px){
            top:0;
            .mImg{
                display: none;
            }
            .mImg2{
                display: block;
            }
            .mNav .burger{
                background-color: #0C3665;
            }
        }
    }
</style>